import { gql, useQuery } from "@apollo/client"
import { useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { ROUTES } from "../Layout/routes"
import { pathForTab } from "../Functions/pathTabs"

const SubrogationClaimRedirectQuery = gql`
    query SubrogationClaimRedirectQuery($id: ID!) {
        subrogationClaim(id: $id) {
            id
            incident {
                id
            }
        }
    }
`

const SubrogationClaimRedirect = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const { data, loading, error } = useQuery(SubrogationClaimRedirectQuery, {
        variables: { id },
        skip: !id,
    })

    useEffect(() => {
        const incidentId = data?.subrogationClaim?.incident?.id
        if (incidentId) {
            navigate(`/incident/${incidentId}#claims`, { replace: true })
        }
    }, [data?.subrogationClaim?.incident?.id, navigate])

    if (loading) {
        return <div className="p-3">Opening subrogation claim...</div>
    }

    if (error || !data?.subrogationClaim?.incident?.id) {
        return (
            <div className="p-3">
                Unable to find the incident for this subrogation claim.{" "}
                <Link to={pathForTab(ROUTES.claims, "subro")}>Go to Subrogation Claims List</Link>
            </div>
        )
    }

    return <div className="p-3">Redirecting...</div>
}

export default SubrogationClaimRedirect
